export default __webpack_public_path__ + "static/media/IMG_3064_2_11zon.2b1683ca.jpg";